<template>
  <div class="coupon-list">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2 class="mb-0">{{ $t('coupon.title') }}</h2>
      <router-link :to="{ name: 'AddCoupon' }" class="btn btn-primary">
        <b-icon icon="plus" class="icon-style"></b-icon>
        {{ $t('coupon.add') }}
      </router-link>
    </div>

    <CrudTable :columns="fields" :data-sources="coupons" :loader="isLoading" list-url="/coupons" ref="action-table">
      <template #cell(sr_no)="data">
        {{ (currentPage - 1) * perPage + data.index + 1 }}
      </template>

      <template #cell(is_active)="data">
        <span class="badge px-3 py-1 rounded-pill"
          :class="data.item.is_active ? 'bg-success text-white' : 'bg-danger text-white'">
          {{ data.item.is_active ? $t('coupon.active') : $t('coupon.inactive') }}
        </span>
      </template>

      <template #cell(actions)="data">
        <div class="d-flex gap-2">
          <router-link :to="{ name: 'EditCoupon', params: { id: data.item.id } }" class="btn btn-outline-primary btn-sm"
            title="Edit">
            <i class="fas fa-edit"></i>
          </router-link>

          <b-button variant="outline-danger" size="sm" @click="confirmDelete(data.item)">
            <i class="fas fa-trash"></i>
          </b-button>
        </div>
      </template>
    </CrudTable>

    <ConfirmDeleteModal v-if="selectedItem" :show.sync="showDeleteModal" :item-id="selectedItem.id"
      delete-url="/coupons" :message="$t('coupon.confirm_delete_message', { code: selectedItem.code })"
      success-message="$t('coupon.deleted_successfully')" error-message="$t('common.something_went_wrong')"
      @deleted="handleItemDeleted" />
  </div>
</template>

<script>
import CrudTable from '@/components/CrudTable.vue';
import ConfirmDeleteModal from '@/components/ConfirmDeleteModal.vue';
import { request } from '@/Util/Request';
export default {
  name: 'CouponList',
  components: {
    CrudTable,
    ConfirmDeleteModal,
  },
  data() {
    return {
      coupons: [],
      isLoading: false,
      currentPage: 1,
      perPage: 10,
      showDeleteModal: false,
      selectedItem: null,
      searchQuery: '', // Add search query tracking
      sortOptions: { // Add sort options tracking
        orderBy: '',
        sortBy: false
      },
      fields: [
        { key: 'sr_no', label: this.$t('common.sr_no'), sortable: false },
        { key: 'code', label: this.$t('coupon.code'), sortable: true },
        { key: 'type', label: this.$t('coupon.type'), sortable: true },
        { key: 'value', label: this.$t('coupon.value'), sortable: true },
        { key: 'starts_at', label: this.$t('coupon.starts_at'), sortable: true },
        { key: 'expires_at', label: this.$t('coupon.expires_at'), sortable: true },
        { key: 'usage_limit', label: this.$t('coupon.usage_limit'), sortable: true },
        { key: 'usage_limit_per_user', label: this.$t('coupon.usage_limit_per_user'), sortable: true },
        { key: 'is_active', label: this.$t('coupon.status'), sortable: true },
        { key: 'actions', label: this.$t('common.actions'), sortable: false },
      ],
    };
  },

  methods: {
    async fetchCoupons() {
      this.isLoading = true;
      try {
        const params = {
          page: this.currentPage,
          perPage: this.perPage,
          search: this.searchQuery,
          orderBy: this.sortOptions.orderBy,
          sortBy: this.sortOptions.sortBy
        };

        const response = await request({
          method: 'get',
          url: '/coupons',
          params
        });

        this.coupons = response.data.data; // Paginated data
        this.$refs['action-table'].pagination = {
          total: response.data.total,
          per_page: response.data.per_page,
          current_page: response.data.current_page,
          last_page: response.data.last_page
        };
      } catch (error) {
        console.error('Error fetching coupons:', error);
      } finally {
        this.isLoading = false;
      }
    },

    handleSearch(search) {
      this.searchQuery = search;
      this.currentPage = 1; // Reset to first page on new search
      this.fetchCoupons();
    },

    handlePageChange(page) {
      this.currentPage = page;
      this.fetchCoupons();
    },

    handlePerPageChange(perPage) {
      this.perPage = perPage;
      this.currentPage = 1; // Reset to first page when changing items per page
      this.fetchCoupons();
    },

    handleSort(sortOptions) {
      this.sortOptions = sortOptions;
      this.fetchCoupons();
    },
    confirmDelete(item) {
      this.selectedItem = item;
      this.showDeleteModal = true;
    },
    handleItemDeleted() {
      this.$refs['action-table'].refreshTableData();
      this.$bvToast.toast(this.$t('coupon.deleted_successfully'), {
        title: this.$t('common.success'),
        variant: 'success',
        solid: true,
      });
      this.showDeleteModal = false;
      this.selectedItem = null;
    },
  },
  created() {
    this.fetchCoupons(); // Initial load
  }
};
</script>

<style scoped>
/* Add any specific styles here if needed */
</style>
